import React from 'react';
interface StatBadgeProps {
  icon: React.ReactNode;
  text: string;
  variant?: 'light' | 'dark';
}
export function StatBadge({
  icon,
  text,
  variant = 'light'
}: StatBadgeProps) {
  const isDark = variant === 'dark';
  return <div className={`inline-flex items-center gap-2.5 px-4 py-2 rounded-full text-sm font-bold ${isDark ? 'bg-white/10 text-white/90 border border-white/20' : 'bg-white text-navy border border-gray-100 shadow-sm'}`} data-id="element-184">
      <span className="flex-shrink-0" data-id="element-185">{icon}</span>
      <span data-id="element-186">{text}</span>
    </div>;
}